<template>
  <el-dialog
      :close-on-click-modal="false"
      title="修改订单费用"
      width="620px"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <el-form label-width="130px" size="small" class="order-fee-edit-form">
        <el-form-item label="载重量（立方）">
          <el-input v-model="form.goodsSquare" placeholder="请输入">
            <span slot="suffix" class="inputSlotText">立方</span>
          </el-input>
        </el-form-item>
        <el-form-item label="载重量（吨）">
          <el-input v-model="form.goodsWeight" placeholder="请输入">
            <span slot="suffix" class="inputSlotText">吨</span>
          </el-input>
        </el-form-item>
        <el-form-item label="背靠背税点">
          <el-input v-model="form.sign" placeholder="请输入">
            <span slot="suffix" class="inputSlotText">%</span>
          </el-input>
        </el-form-item>
        <el-form-item label="应收运费">
          <el-input v-model="form.costPrice" placeholder="请输入">
            <span slot="suffix" class="inputSlotText">元</span>
          </el-input>
        </el-form-item>
        <el-form-item label="应付运费">
          <el-input v-model="form.fullFreight" placeholder="请输入">
            <span slot="suffix" class="inputSlotText">元</span>
          </el-input>
        </el-form-item>
        <el-form-item label="税点及操作费用">
          <el-input v-model="form.taxPoint" placeholder="请输入">
            <span slot="suffix" class="inputSlotText">%</span>
          </el-input>
        </el-form-item>
        <el-form-item label="其他">
          <el-input v-model="form.otherFee" placeholder="请输入">
            <span slot="suffix" class="inputSlotText">元</span>
          </el-input>
        </el-form-item>
      </el-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="sub" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  getOrderFee,
  setOrderFee,
} from 'api/operate';

export default {
  data () {
    return {
      getDetailLoading: false,
      dialogFormVisible: false,
      subLoading: false,
      originData: {},
      form: {
        goodsSquare: '',
        goodsWeight: '',
        sign: '',
        costPrice: '',
        fullFreight: '',
        taxPoint: '',
        otherFee: '',
      },
    };
  },
  methods: {
    normalizeValue (value) {
      if (value === null || value === undefined || value === '/') {
        return '';
      }
      return String(value).replace(/元/g, '').replace(/%/g, '');
    },
    resetForm () {
      this.form = {
        goodsSquare: '',
        goodsWeight: '',
        sign: '',
        costPrice: '',
        fullFreight: '',
        taxPoint: '',
        otherFee: '',
      };
    },
    async show (item) {
      this.dialogFormVisible = true;
      this.originData = item || {};
      this.resetForm();
      this.form.goodsSquare = this.normalizeValue(this.originData.goodsSquare);
      this.form.goodsWeight = this.normalizeValue(this.originData.goodsWeight);
      this.form.sign = this.normalizeValue(this.originData.kappaTaxPointDouble || this.originData.kappaTaxPointStr || this.originData.sign);
      this.getDetailLoading = true;
      try {
        const feeRes = await getOrderFee({
          orderId: this.originData.orderId,
        });
        this.form.costPrice = this.normalizeValue(feeRes.costPriceDouble !== undefined ? feeRes.costPriceDouble : this.originData.costPriceDouble);
        this.form.fullFreight = this.normalizeValue(feeRes.fullFreightDouble !== undefined ? feeRes.fullFreightDouble : (this.originData.fullFreightDouble || this.originData.freightPayableDouble));
        this.form.sign = this.normalizeValue(feeRes.kappaTaxPointDouble !== undefined ? feeRes.kappaTaxPointDouble : this.form.sign);
        this.form.taxPoint = this.normalizeValue(feeRes.taxPointDouble !== undefined ? feeRes.taxPointDouble : this.originData.taxPointAndOperFeeDouble);
        this.form.otherFee = this.normalizeValue(feeRes.otherFeeDouble !== undefined ? feeRes.otherFeeDouble : this.originData.otherFeeDouble);
      } finally {
        this.getDetailLoading = false;
      }
    },
    async sub () {
      this.subLoading = true;
      try {
        const res = await setOrderFee({
          orderId: this.originData.orderId,
          goodsSquare: this.form.goodsSquare,
          goodsWeight: this.form.goodsWeight,
          costPrice: this.form.costPrice,
          fullFreight: this.form.fullFreight,
          taxPoint: this.form.taxPoint,
          otherFee: this.form.otherFee,
          kappaTaxPoint: this.form.sign,
        });
        if (!res.failed) {
          this.dialogFormVisible = false;
          this.$message({
            type: 'success',
            message: '保存成功',
          });
          this.$emit('sub');
        }
      } finally {
        this.subLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.order-fee-edit-form {
  padding-right: 24px;
}
.inputSlotText {
  color: #909399;
}
</style>
